import React from 'react';
import { useAssessment } from '../../context/AssessmentContext';
import { useDialog } from '../../context/DialogContext';
import styles from '../../styles/assessmentFlow.module.css';

const WelcomeScreen: React.FC = () => {
  const { dispatch } = useAssessment();
  const { showHelp } = useDialog();

  const handleStartAssessment = () => {
    dispatch({ type: 'SET_CURRENT_STEP', payload: 'levelA' });
  };

  const showSafetyInfo = () => {
    showHelp({
      title: 'Safety & Support',
      content: `
## If you're in immediate danger or deep distress:

**Call 988** - National Suicide & Crisis Lifeline (US)
**Call 1-800-662-HELP** - SAMHSA National Helpline (24/7)

## About this assessment:

This self-assessment is designed to help you reflect on patterns in your life. It's not a diagnosis or medical advice - only you can decide if a recovery program is right for you.

**Your privacy matters:** All answers stay private on this device unless you choose to save them.

**Take your time:** There are no right or wrong answers. Be honest with yourself about what you're experiencing.
      `
    });
  };

  return (
    <div className={styles.welcomeScreen}>
      <div className={styles.welcomeContent}>
        <div className={styles.welcomeActions}>
          <button
            onClick={handleStartAssessment}
            className={styles.startButton}
            type="button"
          >
            Begin Assessment
          </button>
        </div>

        <div className={styles.welcomeInfo}>
          <p>
            Many people wonder whether their struggles are "bad enough" or what kind of problem they have. 
            This short self-assessment isn't a diagnosis — it's a way to reflect on patterns in your life 
            and explore recovery options that might help.
          </p>
          
          <p>
            You'll answer some general questions first, then choose specific areas you'd like to explore further. 
            The process takes about 5-10 minutes and is completely private.
          </p>

          <div className={styles.safetyNotice}>
            <button 
              onClick={showSafetyInfo}
              className={styles.safetyButton}
              type="button"
            >
              ⚠️ Safety & Support Information
            </button>
          </div>


        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
